<template>
  <div class="alumn-container">
    <div class="common-title">
      <span>专辑</span>
      <span @click="$router.push('/alumn')">更多<van-icon name="arrow"/></span>
    </div>
    <div v-if="alumnList.length" class="alumn-item-container">
      <alumnItem :alumn="alumn" v-for="(alumn, index) in alumnList" :key="index" />
    </div>
    <van-empty v-else description="暂无专辑"></van-empty>
  </div>
</template>

<script>
import {getHomeAlumns} from '@/api'
import alumnItem from './alumnItem.vue'
export default {
  components: {
    alumnItem
  },
  data() {
    return {
      alumnList: []
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      getHomeAlumns().then(res => {
        if (res.code === 0) {
          this.alumnList = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.alumn-container {
}
.common-title {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  span {
    &:nth-child(1) {
      font-size: 16px;
      color: rgba(48, 49, 51, 1);
      font-weight: 700;
    }
    &:nth-child(2) {
      color: #909399;
      font-size: 13px;
    }
  }
}
</style>
